import React, { useState } from 'react';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';

import { PageTreeStateUpdater } from '@confluence/page-tree-refresh-state-container';

type UnarchiveSuccessRefreshPageTreeProps = {
	contentId: string;
};

export const UnarchiveSuccessRefreshPageTree = ({
	contentId,
}: UnarchiveSuccessRefreshPageTreeProps) => {
	const [pageTreeUpdated, setPageTreeUpdated] = useState<boolean>(false);
	return (
		<Subscribe to={[PageTreeStateUpdater]}>
			{(pageStateUpdater: PageTreeStateUpdater) => {
				// Make sure we only push the update once
				if (!pageTreeUpdated) {
					// Requests that we fetch the page tree with the newly restored page.
					pageStateUpdater.setForceFetchPageId(contentId);
					// Requests that we highlight the newly restored page in the tree.
					pageStateUpdater.setHighlightPagesIds([contentId]);
					setPageTreeUpdated(true);
				}
				return null;
			}}
		</Subscribe>
	);
};
